/**
 * v3.staff — /v3/staff/send-note.
 * Dual-delivery: Teams adaptive card + SessionEvent row.
 */

import type {
  RequestOptions,
  SendStaffNoteRequest,
  SendStaffNoteResult,
} from '@retail-ops/shared-types';
import type { ApiHttpClient } from '../http.js';

export class StaffApi {
  public constructor(private readonly http: ApiHttpClient) {}

  public sendNote(
    req: SendStaffNoteRequest,
    opts?: RequestOptions
  ): Promise<SendStaffNoteResult> {
    return this.http.post<SendStaffNoteResult>('/v3/staff/send-note', { ...opts, body: req });
  }
}
